export default __webpack_public_path__ + "static/media/12seconds-tv.17831db8.svg";